// ER-2908 (Loi Koopkracht): what is sent with the simulation about promo codes.
//
// - `agent`: the partner code, so that the comparator resolves the promo code of each product for it
//   (`promoCode` on the returned products).
// - `urlPromo`: the promo code given in the URL. It is cumulated with the mapped promo codes: both are
//   sent to Haugazel (two `promo` user fields), none wins over the other.
//
// The comparator answers 400 to the whole simulation when the agent is longer than 20 characters, when an
// agent comes without a valid area (vl, wl or bx), or when the URL promo is longer than 50 characters. In
// those cases the value is simply not sent: the simulation stays the one it has always been.

const MAX_AGENT_LENGTH = 20;
const MAX_URL_PROMO_LENGTH = 50;
const AREAS = ['vl', 'wl', 'bx'];

/**
 * Returns the agent to send with a simulation, or null when none must be sent.
 *
 * @param {*} agent partner code (e.g. AG904912)
 * @param {*} area vl, wl or bx
 * @returns {string|null}
 */
export function simulationAgent(agent, area) {
  const code = typeof agent === 'string' ? agent.trim() : '';

  if (code === '' || code.length > MAX_AGENT_LENGTH || !AREAS.includes(area)) {
    return null;
  }

  return code;
}

/**
 * Returns the URL promo code to send with a simulation, or null when none must be sent.
 *
 * @param {*} promo promo code given in the URL
 * @returns {string|null}
 */
export function simulationUrlPromo(promo) {
  const code = typeof promo === 'string' ? promo.trim() : '';

  return code !== '' && code.length <= MAX_URL_PROMO_LENGTH ? code : null;
}



// WEBPACK FOOTER //
// ./src/helpers/promoAgent.js